import { useState } from 'react';
import { ExternalLink, LogOut } from 'lucide-react';
import CmsDashboard from './cms/CmsDashboard';
import CmsCartes from './cms/CmsCartes';
import CmsActualites from './cms/CmsActualites';
import CmsEvenements from './cms/CmsEvenements';
import CmsGalerie from './cms/CmsGalerie';
import CmsVisuels from './cms/CmsVisuels';
import CmsSettings from './cms/CmsSettings';

export default function AdminSite() {
  const [view, setView] = useState('dashboard');

  const navigate = (v) => setView(v);

  const renderView = () => {
    switch (view) {
      case 'dashboard': return <CmsDashboard navigate={navigate} />;
      case 'cartes': return <CmsCartes navigate={navigate} />;
      case 'actualites': return <CmsActualites navigate={navigate} />;
      case 'evenements': return <CmsEvenements navigate={navigate} />;
      case 'galerie': return <CmsGalerie navigate={navigate} />;
      case 'visuels': return <CmsVisuels navigate={navigate} />;
      case 'settings': return <CmsSettings navigate={navigate} />;
      default: return <CmsDashboard navigate={navigate} />;
    }
  };

  return (
    <div data-testid="admin-site" className="min-h-[70vh]">
      {/* Top header - matching reference */}
      {view === 'dashboard' && (
        <div className="flex items-center justify-between mb-8 pb-4 border-b border-gray-200">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-[#1a2744] rounded-lg flex items-center justify-center text-white text-xs font-bold">
              LM
            </div>
            <div>
              <h1 className="text-xl font-bold text-gray-900">Tableau de bord</h1>
              <p className="text-sm text-gray-500">Le Mas Restaurant Traiteur</p>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <a href="/site/restaurant" target="_blank" rel="noreferrer"
              className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-700"
              data-testid="view-site-link">
              <ExternalLink size={14} /> Voir le site
            </a>
          </div>
        </div>
      )}

      {renderView()}

      {/* Footer */}
      {view === 'dashboard' && (
        <div className="mt-8 pt-4 border-t border-gray-200 flex items-center justify-center gap-3 text-sm text-gray-400">
          <a href="/" className="hover:text-gray-600">Accueil</a>
          <span>·</span>
          <a href="/site/restaurant" target="_blank" rel="noreferrer" className="hover:text-gray-600">Restaurant</a>
          <span>·</span>
          <a href="/site/traiteur" target="_blank" rel="noreferrer" className="hover:text-gray-600">Traiteur</a>
        </div>
      )}
    </div>
  );
}
